module.exports = __webpack_public_path__ + "static/media/binance-wallet.f7d6abc2.svg";